import { render, staticRenderFns } from "./TurnosPresupuesto.vue?vue&type=template&id=6a29449f&scoped=true"
import script from "./TurnosPresupuesto.vue?vue&type=script&lang=js"
export * from "./TurnosPresupuesto.vue?vue&type=script&lang=js"
import style0 from "./TurnosPresupuesto.vue?vue&type=style&index=0&id=6a29449f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29449f",
  null
  
)

export default component.exports